import { FullStoryAnalyticsProvider } from "@/lib/analytics/providers/FullStoryAnalyticsProvider";
import { PostHogAnalyticsProvider } from "@/lib/analytics/providers/PostHogAnalyticsProvider";

export default {
  FullStoryAnalyticsProvider,
  PostHogAnalyticsProvider,
};
